export default "__VITE_ASSET__16f1e6bf__"